import { IconArrowLeft } from '@tabler/icons-react';
import { useNavigate } from 'react-router';
import { SquareIconButton } from './SquareIconButton';

export function BackToClientsButton() {
  const navigate = useNavigate();

  return (
    <SquareIconButton
      diameter={48}
      radius={20}
      aria-label="Back to clients"
      data-testid="back-to-clients"
      onClick={() => navigate('/clients/all')}
    >
      <IconArrowLeft size={24} color="var(--mantine-color-gray-9)" />
    </SquareIconButton>
  );
}
